import { Component, OnInit, HostListener } from '@angular/core';
import { UserService } from '../../services/user.service';
import { ModalService, MODAL } from '../../services/modal.service';
import { BymeService } from '../../services/byme.service';
import { Router } from '@angular/router';
import { ProjectService } from '../../services/project.service';
import { CurrentService } from '../../services/current.service';
import { Tools } from '../../services/tools';
import { Key } from 'ts-keycode-enum';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';
import { environment } from 'src/environments/environment';
import { ProjectDuplicate } from 'src/app/model/project-duplicate';
import { DatasService } from 'src/app/services/datas.service';

@Component({
  selector: 'ng-hbm-bdi-projects',
  templateUrl: './projects.component.html'
})
export class ProjectsComponent implements OnInit {

  projectsDatas: any;
  displayedProject: any;
  vendorContext: boolean;
  searchInputValue: string = "";
  customerName: string;
  currentTab: string = "all";
  otherAccount: boolean = false;


  constructor(
    public modalService: ModalService,
    private byMe: BymeService,
    public customer: UserService,
    public current: CurrentService,
    public project: ProjectService,
    private router: Router,
    private datas: DatasService,
    private gtm: GTM
  ) { }

  async ngOnInit(): Promise<void> {
    this.gtm.trackPage('my-projects', this.customer.context);
    if (this.customer.userDatas) {
      this.customerName = this.customer.userDatas.completeName;

      if (this.customer.userDatas.otherAccount) {
        this.customerName = this.customer.userDatas.otherAccount.completeName;
        this.otherAccount = true;
      }
    }

    if (this.modalService.currentDatas?.tabKey) {
      this.currentTab = this.modalService.currentDatas.tabKey;
    }

    //si c'est un vendeur, et qu'il n'est pas connecté avec un compte client, il faut récupérer un token
    if (this.customer.userDatas.vendor && !this.customer.userDatas.otherAccount) {
      await this.byMe.acquireToken(this.customer.userDatas.hbmId, false)
    }

    this.projectsDatas = await this.project.getAllFromUser(this.customer.userDatas.otherAccount ?
      this.customer.userDatas.otherAccount.hbmId :
      this.customer.userDatas.hbmId);

    this.filterDisplayedProjects();
  }

  close() {
    this.gtm.trackEvent('click', 'my-projects', 'close');
    this.modalService.close();
  }

  filterDisplayedProjects() {
    // if (this.searchInputValue.trim() == "") {
    //   this.displayedProject = [...this.projectsDatas];
    //   return;
    // }
    let _searchValue = Tools.removeAccents(this.searchInputValue.trim().toLowerCase());
    this.displayedProject = this.projectsDatas.filter((p: any) => {
      if (_searchValue != "") {
        if (!p.search.includes(_searchValue)) return false;
      }

      let displayProject: boolean = false;
      if (this.currentTab == "all") displayProject = true;
      else if ((this.currentTab == CONTEXT.KITCHEN) && 
      (p.distributionID == environment.byMe.kitchenDistribIdEs || p.distributionID == environment.byMe.kitchenDistribIdPt )) {
        displayProject = true;
      }
      else if ((this.currentTab == CONTEXT.STORAGE) && 
      (p.distributionID == environment.byMe.storageDistribIdEs || p.distributionID == environment.byMe.storageDistribIdPt)) {
        displayProject = true;
      } 
      else if ((this.currentTab == CONTEXT.BATHROOM) &&
      (p.distributionID == environment.byMe.bathroomDistribIdEs || p.distributionID == environment.byMe.bathroomDistribIdPt)) {
        displayProject = true;
      }

      return displayProject;
    });
  }

  backToCustomerSearch() {
    this.gtm.trackEvent('click', 'my-projects', 'back-to-search');
    this.modalService.display(MODAL.SEARCH_CUSTOMER, {
      onCustomerSelect: () => {
        this.modalService.display(MODAL.PROJECTS, { customerId: this.customer.userDatas.hbmId });
      }
    });
  }

  async editProject(project: any, event: Event) {
    event.stopPropagation();

    let projectDuplicate: ProjectDuplicate = await this.datas.getProjectDuplicate(project.projectID);

    this.current.project = {
      id: project.projectID,
      uuid: project.projectUUID,
      name: project.projectName,
      description: project.description,
      originalId: projectDuplicate?.originalProjectId ?? project.projectID
    }
    
    this.byMe.prepareBymeSettingsForLoadingProject();
    this.router.navigate([this.currentTab + '/configuration']);
    this.modalService.close();
  }

  newProject(event: Event) {
    event.stopPropagation();
    this.gtm.trackEvent('click', 'my-projects', 'new-project');
    if (this.currentTab === CONTEXT.KITCHEN) {
      this.router.navigate([this.currentTab + '/design']);
    } else {
      this.router.navigate([this.currentTab + '/configuration'])
    }
    
    this.modalService.close();
    this.customer.resetPhone();
  }

  openProject(projectUUID: string, event: Event) {
    if (!this.otherAccount) {
      event.stopPropagation();
      this.gtm.trackEvent('click', 'my-projects', 'open-project');
      this.router.navigate(['projects', projectUUID]);
      this.modalService.close();
      this.customer.resetPhone();
    }    
  }

  duplicateProject(projectUUID: string, projectID: number, projectName: string, event: Event) {
    event.stopPropagation();
    this.gtm.trackEvent('click', 'my-projects', 'duplicate-project');
    this.modalService.display(MODAL.PROJECT_DUPLICATE, {
      projectID: projectID,
      projectUUID: projectUUID,
      projectName: projectName,
      onClose: (clonedProjectUUID) => {
        if (clonedProjectUUID) {
          this.router.navigate(['projects', clonedProjectUUID]);
          this.modalService.close();
        } else {
          this.modalService.display(MODAL.PROJECTS, { customerId: this.customer.userDatas.hbmId });
        }
      }
    });
    this.customer.resetPhone();
  }

  deleteProject(projectID: number, event: Event) {
    event.stopPropagation();
    this.gtm.trackEvent('click', 'my-projects', 'delete-project');
    this.modalService.display(MODAL.PROJECT_DELETE, {
      projectID: projectID,
      onClose: () => {
        this.modalService.display(MODAL.PROJECTS, { customerId: this.customer.userDatas.hbmId });
      }
    });
    this.customer.resetPhone();
  }

  setTab(tab: string) {
    this.currentTab = tab;
    this.filterDisplayedProjects();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.which === Key.Enter) {
      this.filterDisplayedProjects();
    }
  }
}
